module.exports = __webpack_public_path__ + "img/banner.63148961.jpg";